import { render, staticRenderFns } from "./companypagestwo.vue?vue&type=template&id=25a967b2&scoped=true&"
import script from "./companypagestwo.vue?vue&type=script&lang=js&"
export * from "./companypagestwo.vue?vue&type=script&lang=js&"
import style0 from "./companypagestwo.vue?vue&type=style&index=0&id=25a967b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a967b2",
  null
  
)

export default component.exports